import { Position } from '@src/main/modules/parameters/domain/fleet-positions/position.interface';

export interface PositionEntity {
  positionId: string;
  position: string;
  description: string;
  fleets?: string[];
}

export function toPosition(entity: PositionEntity): Position {
  return {
    ...entity,
  };
}

export function fromPosition(model: Position): PositionEntity {
  return {
    ...model,
  };
}
